<template>
    <div :class="styles.arrayList.item">
        <DFormRow
            class="p-2 bg-light rounded-3"
            :label="label"
            @click="expandClicked"
        >
            <div class="text-right">
                <DButton
                    :disabled="!moveUpEnabled"
                    class="flex"
                    icon="chevron-up"
                    @click.prevent="moveUpClicked"
                />
                <DButton
                    :disabled="!moveDownEnabled"
                    :class="styles.arrayList.itemMoveDown"
                    icon="chevron-down"
                    @click.prevent="moveDownClicked"
                />
                <DButton
                    :disabled="!deleteEnabled"
                    :class="styles.arrayList.itemDelete"
                    icon="trash-can-outline"
                    color="danger"
                    @click.prevent="deleteClicked"
                />
            </div>
        </DFormRow>
        <div :class="contentClasses">
            <slot />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { classes } from '@jsonforms/vue-vanilla'
import { cilChevronDoubleUp } from '@coreui/icons'

const listItem = defineComponent({
    name: 'ArrayListElement',
    props: {
        initiallyExpanded: {
            required: false,
            type: Boolean,
            default: false,
        },
        label: {
            required: false,
            type: String,
            default: '',
        },
        moveUpEnabled: {
            required: false,
            type: Boolean,
            default: true,
        },
        moveDownEnabled: {
            required: false,
            type: Boolean,
            default: true,
        },
        moveUp: {
            required: false,
            type: Function,
            default: undefined,
        },
        moveDown: {
            required: false,
            type: Function,
            default: undefined,
        },
        deleteEnabled: {
            required: false,
            type: Boolean,
            default: true,
        },
        delete: {
            required: false,
            type: Function,
            default: undefined,
        },
        styles: {
            required: true,
            type: Object,
        },
    },
    data () {
        return {
            expanded: this.initiallyExpanded,
        }
    },
    computed: {
        contentClasses () {
            return classes`${this.styles.arrayList.itemContent} ${
                this.expanded && this.styles.arrayList.itemExpanded
            }`
        },
        toolbarClasses () {
            return classes`${this.styles.arrayList.itemToolbar} ${
                this.expanded && this.styles.arrayList.itemExpanded
            }`
        },
    },
    methods: {
        cilChevronDoubleUp () {
            return cilChevronDoubleUp
        },
        expandClicked () {
            this.expanded = !this.expanded
        },
        moveUpClicked (event) {
            event.stopPropagation()

            this.moveUp?.()
        },
        moveDownClicked (event) {
            event.stopPropagation()

            this.moveDown?.()
        },
        deleteClicked (event) {
            event.stopPropagation()

            this.delete?.()
        },
    },
})

export default listItem
</script>
